<div class="loading-interno animate__faster animate__animated animate__fadeIn">
  <img
    src="https://simpliassets12daacw.s3.us-east-2.amazonaws.com/Loader.gif"
    style="height: 100px"
  />
  <mat-label>La información está siendo procesada</mat-label>
  <mat-label>Esto no tomará mucho tiempo.</mat-label>
</div>